import {IntermediatePart} from "../../parts/intermediatePart";
import DesignNavigationItem from "../../../../visComponents/designNavigationItem";

import {ShowerTubCombo} from "../../parts/showerTubCombo";
import {Vanity} from "../../parts/vanity";
import { ShowerComboTubType } from "../../constants";
import { getMetadataByDimensions } from "../../../../../misc/utils";
import {getFeatureIsLocked} from "../../../../../misc/helpers";

export default class ShowerDoor extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.partId = 'shower_door';
    this.partName = 'Shower Door';
    this.translateId = "visualizer.bathroom.shower.shower_door";
    this.visible = true;
    this.isStoneFeature = false;
    this.canBeDisabled = true;
    this.layerPriority = 5;

    /* only shower door properties */
    if (isChild) {
      this.previouslySelectedFeatures = {
        LG: {},
        SM: {}
      };
    }
    this.currentShowerBodyId = ""; // for example "custom-a-60in-30x8"
  }

  load(dbFeature) {
    const doorFeature = this.load_(dbFeature, new ShowerDoor());
    if (doorFeature) {
      ShowerDoor.setAdditionalMetaData(doorFeature);
    }
  }

  static setAdditionalMetaData(doorFeature) {
    if (!doorFeature.metaData["CompatibleTub"]) {
      doorFeature.metaData["CompatibleTub"] = ["None"];
    }
  }

  disabledClick() {
    const showerDoorHandle = this.getParent().showerDoorHandle;
    if (showerDoorHandle) {
      showerDoorHandle.disabled = this.disabled;
    }
  }

  handleClick() {
    super.handleClick();
    if (!this.notAvailableInVisualizer && !getFeatureIsLocked(this)) {
      // this.getParent().getParent().setShowerTubCombo();
      // let doorWithLiner = false;
      // if(this.metaData && this.metaData.length) {
      //   const activeDoorMetadata = this.metaData.find(metaDataObject => metaDataObject.isFor);
      //   const showerPanValues = activeDoorMetadata.conditions.find(condition => condition.name === "BathtubLiner");
      //   if (showerPanValues) {
      //     doorWithLiner = true;
      //   }
      // }
      // this.getParent().getParent().setLinerActive(doorWithLiner);
      const shower = this.getParent().getParent();
      const showerPanCondition = this.metaData["ShowerPan"];
      if (!shower.showerTubComboIsActive()) {
        shower.showerFloorIsActive = showerPanCondition && showerPanCondition.includes("Threshold");
      }
      if(!this.matchesMetaForArrayOfConditions(this.getParent().getArrayOfConditions())) {
        const showerSizeValues = this.metaData["ShowerSize"];
        const showerBodyParent = this.getParent().getParent().showerBody;
        if (showerSizeValues) {
          const showerBodyThatFits = showerBodyParent.features.filter(showerBodyFeature => {
            const showerSizeValues2 = showerBodyFeature.metaData["ShowerSize"];
            return showerSizeValues.some(condValue => {
              return showerSizeValues2.some(condValue2 => condValue === condValue2);
            });
          });
          if (showerBodyThatFits.length && showerBodyThatFits.every(shBody => shBody.partName !== showerBodyParent.activeFeature.partName)) {
            let showerBodyToSet = showerBodyThatFits.find(shBody => {
              return shBody.showerDimensions === showerBodyParent.activeFeature.showerDimensions
            }) || showerBodyThatFits[0];
            showerBodyParent.showerBodySelectedByUser = true;
            showerBodyParent.activeFeature = showerBodyToSet;
          }
        }
      }
      this.featureClicked();
    }
  }

  navigationSubItems(filters, searchText) {
    const shower = this.getParent();
    const filteredAvailableFeatures = super.getFeaturesBySearchText(super.getFilteredFeaturesByFilters(filters), searchText);
    const featuresToDisplay = super.navigationSubItemsWithFilterMultipleConditions(this.getArrayOfConditions(shower.showerFloorIsActive), filteredAvailableFeatures);
    return featuresToDisplay.map(_ => new DesignNavigationItem(_.featureName, _));
  }

  setLayers(layout) {
    const shower = this.getParent();
    const currentConditions = this.getArrayOfConditions(shower.showerFloorIsActive);

    if (this.activeFeature && !this.activeFeature.notAvailableInVisualizer && this.activeFeature.matchesMetaForArrayOfConditions(currentConditions)) {
      this.checkIfPlaceHolderFits(currentConditions);  // here we need to check if placeholder is the same as active feature
      return super.setLayers(layout);
    }

    this.setDefault();
    this.checkIfPlaceHolderFits(currentConditions);
    return super.setLayers(layout);
  }

  checkIfPlaceHolderFits(currentConditions) {
    if (this.activeFeature && !this.placeholderChanged) {
      const activeFeatureShowerPanCondition = this.activeFeature.metaData["ShowerPan"];
      if (activeFeatureShowerPanCondition) {
        currentConditions.push({
          propName: "ShowerPan",
          propValue: activeFeatureShowerPanCondition
        });
        if (!this.placeholderFeature || this.placeholderFeature.notAvailableInVisualizer
          || (this.placeholderFeature && !this.placeholderFeature.matchesMetaForArrayOfConditions(currentConditions))) {
          this.setNewPlaceHolderFeature(currentConditions);
        }
      }
    }
  }

  setNewPlaceHolderFeature(newConditions) {
    // console.log('newConditions', newConditions);
    const filteredFeatures = this.features ? this.features.filter(f => f.matchesMetaForArrayOfConditions(newConditions)) : [];
    const placeholderDefault = filteredFeatures.find((feature) => {
      return feature.dbFeature.displayName && feature.dbFeature.displayName.includesCI("placeholder");
    });
    this.placeholderFeature = placeholderDefault || null;
  }

  getArrayOfConditions(showerFloorIsActive) {
    const layout = this.getParent().layout;
    const showerComboParent = layout.parts[ShowerTubCombo.id];
    const showerParent = this.getParent();

    let showerDimensions = showerComboParent.showerTubComboIsActive
      ? showerComboParent.showerDimensions()
      : showerParent.showerDimensions();

    showerDimensions = getMetadataByDimensions(showerDimensions);

    const vanity = layout.parts[Vanity.id];
    let counterTopSize = vanity.counterTopSize();
    if (counterTopSize === '72in' && layout.type === 1 && (showerDimensions !== "Full" || showerDimensions !== "Pony")) {
      showerDimensions = "Full"
    }

    let showerSize = showerComboParent.showerTubComboIsActive
      ? showerComboParent.showerSize()
      : showerParent.showerSize();

    let compatibleValue = "None";
    if (showerComboParent.showerTubComboIsActive) {
      if (showerComboParent.bottomTub === ShowerComboTubType.bathtub_liner) {
        compatibleValue = "BathtubLiner"
      } else if (showerComboParent.bottomTub === ShowerComboTubType.replacement_tub) {
        compatibleValue = "ReplacementTub"
      } else if (showerComboParent.bottomTub === ShowerComboTubType.walk_in_tub) {
        compatibleValue = "WalkInTub"
      } else if (showerComboParent.bottomTub === ShowerComboTubType.jetted_tub) {
        compatibleValue = "JettedTub"
      }
    }
    const conditions = [{
      propName: 'ShowerSize',
      propValue: showerSize
    },{
      propName: "EX L",
      propValue: showerDimensions
    },{
      propName: 'CompatibleTub',
      propValue: compatibleValue
    }];
    if (!showerComboParent.showerTubComboIsActive) {
      if (showerFloorIsActive) {
        conditions.push({
          propName: "ShowerPan",
          propValue: ["Threshold"]
        })
      } else if (showerParent.showerPanCombo && showerParent.showerPanCombo.activeFeature) {
        let showerPanCondition = showerParent.showerPanCombo.activeFeature.metaData["ShowerPan"];
        // console.log('showerPanCondition', showerPanCondition);
        if (showerPanCondition) {
          conditions.push({
            propName: "ShowerPan",
            propValue: showerPanCondition
          })
        }
      }
    }
    return conditions
  }

  setDefault() {
    const shower = this.getParent();
    const currentActiveFeature = this.activeFeature;
    const currentConditions = this.getArrayOfConditions(shower.showerFloorIsActive)
    const filteredFeatures = this.features.filter(f => !f.notAvailableInVisualizer && f.matchesMetaForArrayOfConditions(currentConditions));
    if (!this.tryToSetTheSameFeature(filteredFeatures)) {
      this.setDefaultAccordingToPreviousSelect(shower, filteredFeatures, "", "Placeholder");
    }
    this.rememberPreviousSelection(shower, currentActiveFeature);
    // shower.showerFloorIsActive = !!(this.activeFeature && this.activeFeature.metaData["ShowerPan"]
    //   && this.activeFeature.metaData["ShowerPan"].includes("Threshold"));
  }

  tryToSetTheSameFeature(filteredFeatures) {
    if (this.activeFeature && this.activeFeature.partName) {
      const nameToFind = this.activeFeature.partName.replace(" 30", "").replace(" 60", "");
      this.activeFeature = !nameToFind.includes("laceholder") && filteredFeatures.find(feature => {
        if (feature.partName) {
          const fName = feature.partName.replace(" 30", "").replace(" 60", "");
          return fName.includes(nameToFind)
        }
      });
      this.placeholderFeature = filteredFeatures.find((feature) => {
        return feature.dbFeature.displayName && feature.dbFeature.displayName.includesCI("placeholder")
      });
      if (this.activeFeature) {
        return true
      }
    }
    return false
  }

  setZIndex(zIndexes) {
    const zIndex = zIndexes.Shower.Custom60in.ShowerDoor;
    if (zIndexes && this.activeFeature) {
      this.activeFeature.layer.zIndex = zIndex;
    }
    if (zIndexes && this.placeholderFeature) {
      this.placeholderFeature.layer.zIndex = zIndex;
    }
  }
}
